import { Box, Text } from "@saleor/macaw-ui-next";
import React from "react";
import { useIntl } from "react-intl";

import { messages } from "./messages";
import { WizardProgress } from "./WizardProgress";

interface WizardLayoutProps {
  children: React.ReactNode;
}

export const WizardLayout: React.FC<WizardLayoutProps> = ({ children }) => {
  const intl = useIntl();

  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      backgroundColor="default1"
      overflow="auto"
      style={{
        height: "calc(100vh - 62px)",
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        __flexShrink={0}
        style={{
          paddingTop: "16px",
          paddingBottom: "12px",
          paddingLeft: "12px",
          paddingRight: "12px",
        }}
      >
        <Box width="100%" __maxWidth="1080px">
          <Box display="flex" flexDirection="column" gap={1} marginBottom={{ mobile: 4, tablet: 5 }}>
            <Text
              size={1}
              fontWeight="bold"
              __textTransform="uppercase"
              __letterSpacing="0.08em"
              __color="#3b82f6"
            >
              {intl.formatMessage(messages.storeSetup)}
            </Text>
            <Text size={7} fontWeight="bold">
              {intl.formatMessage(messages.onboardingWizard)}
            </Text>
            <Text size={3} color="default2">
              {intl.formatMessage(messages.onboardingWizardDescription)}
            </Text>
          </Box>

          <WizardProgress />
        </Box>
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        __flex={1}
        __minHeight={0}
        style={{
          paddingLeft: "12px",
          paddingRight: "12px",
          paddingBottom: "16px",
        }}
      >
        <Box
          width="100%"
          __maxWidth="1080px"
          __flex={1}
          __minHeight={0}
          display="flex"
          flexDirection="column"
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};
